import styled from "styled-components";
import { Wrapper, BottomModal } from "../Common/styles.common";

/*
 * GRN screens are designed for mweb but are also served on desktop.
 * Keeping the content at the mweb width and padding the leftover space on both
 * sides preserves the intended aspect ratio instead of stretching the layout.
 */
const GRN_CONTENT_WIDTH = "560px";

/*
 * BottomModal variant that respects GrnPageWrapper's desktop padding.
 * On screens ≥ 768 px the inner panel is clamped to GRN_CONTENT_WIDTH and
 * horizontally centred, matching the rest of the GRN content area.
 */
export const GrnBottomModal = styled(BottomModal)`
  @media only screen and (min-width: 768px) {
    > div:nth-child(2) {
      width: ${GRN_CONTENT_WIDTH};
      left: calc((100vw - ${GRN_CONTENT_WIDTH}) / 2);
    }
  }
`;

export const GrnPageWrapper = styled(Wrapper)`
  @media only screen and (min-width: 768px) {
    padding-left: calc((100% - ${GRN_CONTENT_WIDTH}) / 2);
    padding-right: calc((100% - ${GRN_CONTENT_WIDTH}) / 2);

    /* .infinite-scroll is position: fixed, so its width: 100% resolves against
       the viewport and ignores the padding above. */
    .infinite-scroll {
      width: ${GRN_CONTENT_WIDTH};
    }
  }
`;

export const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background: ${(props) => props.bgColor};
  border: ${(props) => (props.showBorder ? "1px solid #E6E9EF" : "")};
  border-radius: 12px;
  padding: 1px;
`;

export const GrnCardTopTags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: -16px 16px 18px 16px;
`;

export const GrnCardStatusTag = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 100%;
  min-height: 22px;
  padding: 4px 10px;
  background: ${(props) => props.$background || 'grey'};
  color: ${(props) => props.$text_color || 'black'};
  border-radius: 0 0 4px 4px;

  span {
    color: inherit;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const GrnCardStatusFooter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  min-height: 32px;
  margin: 16px 0 -16px 0;
  padding: 10px 16px 10px 20px;
  gap: 16px;
  background: ${(props) => `linear-gradient(90deg, ${props.$bg || "#787878"} 0%, #ffffff 100%)`};
  border-radius:  0 0 12px 16px;
  border: 2px solid var(--color-base-white, rgba(255, 255, 255, 1));
  color: ${(props) => props.$text_color || "#494f58"};

  span {
    color: inherit;
  }
`;

export const GrnDetailsHeaderTag = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 30px;
  width: 100%;
  margin-top: -16px;
  padding: 7px 16px;
  background: ${(props) => props.$background || "#e5f3f3"};
  color: ${(props) => props.$text_color || "#0a757c"};
  border-radius: 0 0 16px 16px;
  box-shadow: 0px 1px 4px 0px rgba(28, 28, 28, 0.06);

  span {
    color: inherit;
    text-align: center;
  }
`;

export const UnpaidTag = styled.div`
  display: flex;
  justifyt-content: center;
  align-items: center;
  padding: 4px 8px 4px 8px;
  background: #256fef;
  color: white;
  border-radius: 100px;
  height: fit-content;
`;

export const PaidTag = styled.div`
  display: flex;
  justifyt-content: center;
  align-items: center;
  padding: 4px 8px 4px 8px;
  background: #119199;
  color: white;
  border-radius: 100px;
  height: fit-content;
`;

export const InvoiceButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
  height: 40px;
  width: 100%;
  border-radius: 8px;
  border: 1px solid #ef4f5f;
`;

export const InvoiceButtonWithDownCNButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
  height: 40px;
  width: 50%;
  border-radius: 8px;
  border: 1px solid #ef4f5f;
`;

export const DownloadCreditNoteButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ef4f5f;
  height: 32px;
  width: 30%;
  border-radius: 10px;
  border: 1px solid #ef4f5f;
  color: white;
  span {
    color: white;
  }
`;

export const ViewCreditNoteButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ef4f5f;
  height: 40px;
  width: 50%;
  border-radius: 8px;
  border: 1px solid #ef4f5f;
  color: white;
  span {
    color: white;
  }
`;

export const SectionCard = styled.div`
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0px 1px 4px rgba(28, 28, 28, 0.06);
  margin: 16px;
`;

export const SectionHeader = styled.div`
  display: flex;
  padding: 14px 16px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;

export const SectionDivider = styled.div`
  height: 1px;
  width: 100%;
  background: #f2f4f7;
`;

export const SectionBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  padding: 12px 16px 16px 16px;
  gap: 12px;
`;

/* Secondary button for raising a dispute (mirrors the one in Common/styles.common.js) */
export const RaiseDisputeOutlineButton = styled.button`
  background: #ffffff;
  height: 40px;
  flex: 1;
  border-radius: 8px;
  border: 1px solid #ef4f5f;
  color: #ef4f5f;
  font-weight: 600;
  font-size: 13px;
`;

export const GrnSummaryCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  padding: 16px;
  border: 1px solid #e6e9ef;
  border-radius: 16px;
  background: #ffffff;
`;

export const GrnSummaryMetrics = styled.div`
  display: flex;
  width: 100%;
  border: 1px solid #e6e9ef;
  border-radius: 12px;
  background: #ffffff;
  overflow: hidden;
`;

export const GrnSummaryMetric = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  justify-content: center;
  min-height: 71px;
  padding: 14px 12px;
  gap: 4px;
  background: #ffffff;

  &:not(:last-child) {
    border-right: 1px solid #f2f4f7;
  }
`;

export const GrnItemCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  background: #ffffff;
  border: 1px solid #f2f4f7;
  border-radius: 16px;
  box-shadow: 0px 1px 4px rgba(28, 28, 28, 0.06);
  padding: 16px;
`;

export const GrnInfoLabelWrapper = styled.div`
  padding: 16px 0px 0px 0px;
  border-radius: 12px;
  margin: 0 16px;
`;

export const GrnSummarySectionWrapper = styled.div`
  padding: 2px;
  border-radius: 12px;
  margin: 16px 16px 0 16px;
`;

export const ItemQtyBox = styled.div`
  display: flex;
  align-self: stretch;
  align-items: center;
  min-height: 72px;
  margin-top: 12px;
  border: 1px solid #f2f4f7;
  border-radius: 12px;
`;

export const ItemQtyDivider = styled.div`
  width: 1px;
  height: 40px;
  background: #f2f4f7;
`;

export const ProductThumb = styled.img`
  height: 48px;
  width: 48px;
  border-radius: 8px;
  object-fit: contain;
  flex-shrink: 0;
`;

export const MandiTag = styled.div`
  display: flex;
  justifyt-content: center;
  align-items: center;
  padding: 4px 8px 4px 8px;
  background: #119199;
  color: white;
  border-radius: 100px;
  height: fit-content;
`;

export const FiltersRow = styled.div`
  display: flex;
  gap: 12px;
  overflow-x: auto;
  padding: 16px;
`;

export const FilterChip = styled.button`
  align-items: center;
  background: ${(props) => (props.$selected ? "#FFF5F6" : "#FFFFFF")};
  border: ${(props) => (props.$selected ? "1px solid #EF4F5F" : "1px solid #E6E9EF")};
  border-radius: 8px;
  box-shadow: 0px 4px 20px rgba(28, 28, 28, 0.04);
  color: ${(props) => (props.$selected ? "var(--color-base-grey-900, #293142)" : "#767C8F")};
  cursor: pointer;
  display: inline-flex;
  flex-shrink: 0;
  font-weight: ${(props) => (props.$selected ? "600" : "normal")};
  gap: 8px;
  min-width: max-content;
  padding: 8px 12px;
`;

export const CrossIconWrapper = styled.span`
  align-items: center;
  display: inline-flex;
  justify-content: center;
`;

export const SearchBarContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const SearchIcon = styled.img`
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  pointer-events: none;
`;

export const SearchBar = styled.input`
  width: 100%;
  padding: 12px 16px 12px 48px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  outline: none;

  &:focus {
    border-color: #ef4f5f;
  }

  &::placeholder {
    color: #9e9e9e;
  }
`;

export const SearchToggleButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  padding: 0;
  border: 1px solid #f0f1f3;
  border-radius: 50%;
  background: white;
  box-shadow: 0px 4px 20px rgba(28, 28, 28, 0.04);
  cursor: pointer;
`;

export const SearchToggleIcon = styled.img`
  width: 18px;
  height: 18px;
`;


// Dispute input row — two-column card layout
export const DisputeRowGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-top: 12px;
`;

export const DisputeCardLabel = styled.span`
  font-size: 12px;
  color: #9ea5b5;
  margin-bottom: 6px;
`;

export const DisputeCardRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const DisputeCardValue = styled.span`
  font-size: 16px;
  font-weight: 500;
  color: #293142;
`;

export const DisputeCardUnit = styled.span`
  font-size: 14px;
  color: #9ea5b5;
`;

export const DisputeNativeInput = styled.input`
  border: none;
  outline: none;
  background: transparent;
  font-size: 16px;
  font-weight: 500;
  color: #293142;
  width: 100%;
  &::placeholder {
    color: #c8cdd8;
    font-weight: 400;
  }
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export const DisputeErrorIcon = styled.img`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  filter: brightness(0) saturate(100%) invert(22%) sepia(96%) saturate(2000%) hue-rotate(349deg) brightness(95%);
`;

export const DisputeItemError = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;

  span {
    color: #e53935;
    font-size: 13px;
    font-weight: 500;
  }
`;

export const DisputeDescriptionError = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 0;

  span {
    color: #e53935;
    font-size: 13px;
    font-weight: 500;
  }
`;

export const DisputeDescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 20px;
  width: 100%;
`;

export const DisputeDescriptionTextarea = styled.textarea`
  width: 100%;
  min-height: 120px;
  background: #f5f5f5;
  border: none;
  outline: none;
  border-radius: 12px;
  padding: 14px;
  font-size: 14px;
  color: #293142;
  resize: vertical;
  font-family: inherit;
  &::placeholder {
    color: #9ea5b5;
  }
`;

export const DisputeClaimText = styled.span`
  display: inline-block;
  font-family: "Our Lexend", sans-serif;
  font-style: medium;
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: 0em;
  color: var(--color-base-orange-500, rgba(232, 108, 55, 1));
  vertical-align: middle;
`;

export const DisputeClaimFooter = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin: 12px -16px -16px -16px;
  padding: 8px 16px;
  border-radius: 0 0 16px 16px;
  background: linear-gradient(90deg, #fff1e6 0%, #ffffff 100%);
`;

export const DisputeClaimInlineShade = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  margin-left: 8px;
  padding: 4px 8px;
  border-radius: 6px;
  background: linear-gradient(90deg, #fff1e6 0%, #ffffff 100%);
`;

export const DisputeInfoLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  background: ${({ $bg_color }) => $bg_color || "#fff5e6"};
  border-radius: 10px;
  border: 2px solid #ffffff;
`;


export const DisputeRaisedInfoBox = styled.div`
  width: 260px;
  min-height: 126px;
  border-radius: 14px;
  border: 1px solid rgba(255, 232, 204, 1);
  border-top: 1px solid rgba(255, 232, 204, 1);
  background: rgba(255, 248, 240, 1);
  padding: 12px 14px;
  gap: 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  opacity: 1;
`;

// OTP verification styles
export const OtpContainer = styled.div`
  margin: 24px auto 8px auto;
`;

export const OtpInputField = styled.input`
  width: 44px;
  height: 52px;
  font-size: 20px;
  font-weight: 600;
  border: none;
  border-bottom: 2px solid var(--color-base-grey-200, rgba(230, 233, 239, 1));
  border-radius: 0;
  background: transparent;
  color: #293142;
  outline: none;
  text-align: center;
`;


export const AmountMetricsRow = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;

export const AmountMetricCell = styled.div`
  display: flex;
  width: 50%;
  flex-direction: column;
  align-items: center;
`;


export const GrnCompletedOnLabel = styled.span`
  font-size: 12px;
  font-weight: 400;
  color: #767c8f;
  margin: 12px;
`;


export const AmountMetricValue = styled.span`
  display: flex;
  align-items: center;
  gap: 2px;
  font-size: 15px;
  font-weight: 700;
`;


export const AmountMetricLabel = styled.span`
  font-size: 13px;
  font-weight: 400;
  color: #767c8f;
  margin-top: 4px;
`;

export const ViewDetailsIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid #e6e9ef;
`;


export const GrnCardOuterWrapper = styled.div`
  margin-top: 16px;
  margin-left: 16px;
  margin-right: 16px;
`;

export const GrnCardFooterText = styled.span`
  font-size: 12px;
  font-weight: 600;
`;
